// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1hEng","title":"Header_title__OXXT7","left":"Header_left__RO0wG","clinicName":"Header_clinicName__3rX18"};